function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function initCardSlider(el) {
  if (el.dataset.swiperInitialized === 'true') return;

  if (!isVisible(el)) {
    var observer = new MutationObserver(function () {
      if (!isVisible(el)) return;
      observer.disconnect();
      initCardSlider(el);
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'style'],
    });

    return;
  }

  el.dataset.swiperInitialized = 'true';

  new Swiper(el, {
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    slidesPerGroup: 1,
    watchOverflow: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: el.querySelector('.swiper-pagination'),
    },
    scrollbar: {
      el: el.querySelector('.swiper-scrollbar'),
    },
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
  });
}

document
  .querySelectorAll('.card-slider .cs-swiper.swiper, .collection-card-slider .cs-swiper.swiper')
  .forEach(initCardSlider);